import React, { useCallback } from 'react';
import { ModalType, useModalContext } from '@/context/ModalContext';
import { NetworkErrorIcon } from '@/icons/errors';
import BaseModal from '@/components/Modal/BaseModal/BaseModal';
import {
  ModalActions,
  ModalCancelButton,
  ModalContent,
  ModalContentText,
  ModalHeader,
  ModalIcon,
  ModalSubmitButton,
  ModalTitle,
} from '@/components/Modal/Elements';
import CloseButton from '@/components/Modal/Elements/Close/CloseButton';
import { useTranslation } from '@/hooks/useTranslation';

interface Props {}

const NetworkErrorModal: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { close } = useModalContext();
  const onClose = useCallback(() => {
    close(ModalType.REQUEST_NETWORK_ERROR);
  }, [close]);
  const onSubmit = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <BaseModal onClose={onClose}>
      <ModalHeader>
        <CloseButton onClick={onClose} />
      </ModalHeader>
      <ModalIcon>
        <NetworkErrorIcon />
      </ModalIcon>
      <ModalContent>
        <ModalTitle>{t('modal.error.network_issue.title')}</ModalTitle>
        <ModalContentText>{t('modal.error.network_issue.sub_title')}</ModalContentText>
      </ModalContent>
      <ModalActions>
        <ModalSubmitButton onClick={onSubmit} text={t('button.try_again')} />
        <ModalCancelButton onClick={onClose} text={t('button.cancel')} />
      </ModalActions>
    </BaseModal>
  );
};

export default NetworkErrorModal;
